import React from "react";
import type { ModuleOptions } from "src/system/module.types.ts";
import { ResourceEnum } from "src/constants/constants.ts";
import type { CountryResource } from "@exonn/js-sdk";

export const module: ModuleOptions<CountryResource> = {
  resource: ResourceEnum.Country,
  bigIcon: <i className="icon-20-countries" />,
  smallIcon: <i className="icon-15-countries" />,
  list: {
    hideDeleteAction: (row) => row.is_default,
  },
  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
};
